import type { DictationStatus } from "./use-dictation";

/** Recording finished — success, failure, or never started. A settled
 *  status accepts a new recording and is safe for a composer or card to
 *  stop owning. Shared by every mic owner so "settled" means one thing
 *  everywhere. */
export function isDictationSettled(status: DictationStatus): boolean {
  return status === "idle" || status === "error";
}

/** Mic button state derived from dictation status and local ownership,
 *  shared by every composer/card that renders its own mic control. */
export function dictationMicState(
  status: DictationStatus,
  owns: boolean,
): { recording: boolean; disabled: boolean } {
  return {
    recording: owns && status === "recording",
    disabled: status === "processing" || (!isDictationSettled(status) && !owns),
  };
}
